import { useState, useEffect, useRef } from "react";

const useDropdownAnimation = (initialState = false) => {
  const [isOpen, setIsOpen] = useState(initialState);
  const dropdownRef = useRef(null);

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const spring = {
    type: "spring",
    stiffness: 500,
    damping: 30,
  };

  const dropdownAnimation = {
    initial: { opacity: 0, y: -20 },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: -20 },
    transition: spring,
  };

  return {
    isOpen,
    setIsOpen,
    dropdownRef,
    dropdownAnimation,
  };
};

export default useDropdownAnimation;
